import { Component, Input, OnInit } from '@angular/core';
import { AppConfig } from '@config/app.config';

@Component({
  selector: 'app-error-view',
  templateUrl: './error-view.component.html'
})
export class ErrorViewComponent implements OnInit {
  @Input() text: string;

  constructor(public appConfig: AppConfig) {}

  ngOnInit() {}
}
